export * from './baMenu.component';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/components/baMenu/index.ts